<template>
  <div class="notice-cont">
    <div class="steps-blk">
      <van-steps
        :active="active"
        inactive-icon="checked"
        v-if="rowDataObj.length > 1"
      >
        <van-step v-if="JSON.stringify(params.notice1) !== '{}'">
          {{ params.notice1.top_label }}
        </van-step>
        <van-step v-if="JSON.stringify(params.notice2) !== '{}'">
          {{ params.notice2.top_label }}
        </van-step>
        <van-step v-if="JSON.stringify(params.notice3) !== '{}'">
          {{ params.notice3.top_label }}
        </van-step>
      </van-steps>
      <div class="one-step" v-else>
        <div>{{ params.notice.top_label }}</div>
        <div style="margin-top: 3px;"><van-icon name="checked" /></div>
      </div>
    </div>
    <div id="main">
      <div style="min-height: calc(100vh - 110px);" class="contents">
        <!-- <div class="cont-title"></div> -->
        <div class="cont-content">
          <div v-html="params.notice.content"></div>
        </div>
      </div>
      <div class="cont-footer">
        <div v-html="params.notice.bottom_version"></div>
      </div>
      <div style="height: 1px;background-color: #f4f5f6;"></div>
    </div>
    <div class="cont-btn">
      <van-button
        block
        :class="count === 0 && scrollToBottom ? 'btnStyle1' : 'btnStyle1-1'"
        @click="nextStep"
      >
        {{
          Number(active) === rowDataObj.length - 1
            ? "我承诺已认真阅读，并严格遵守"
            : "下一条"
        }}{{ count === 0 ? "" : `(${count}秒)` }}
      </van-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: 0,
      count: 0,
      scrollToBottom: false, // 是否滚动到页面底部
      isFirstScroll: true,
      rowDataObj: {},
      params: {
        notice: {},
        notice1: {},
        notice2: {},
        notice3: {}
      },
      bs: null
    };
  },
  mounted() {
    this.getDetail();
    if (this.type === "success") {
      window.removeEventListener("scroll", this.Scrollbottom);
      this.count = 0;
      this.scrollToBottom = true;
    }
  },
  methods: {
    // 下一步
    nextStep() {
      console.log(this.active);
      // 1、未滚动到底部
      // 2、已滚动到底部，但倒计时未结束
      if (!this.scrollToBottom || (this.count !== 0 && this.scrollToBottom)) {
        return false;
      }
      if (
        Number(this.active) === this.rowDataObj.length - 1 &&
        this.count === 0
      ) {
        if (this.type !== "success") {
          // 报到时跳转，则跳转到成功页面
          this.$router.push({
            path: "/rhwxSignInSuccess",
            query: {
              com_id: this.$route.query.com_id,
              sub_com_id: this.$route.query.sub_com_id,
              map_type: this.$route.query.map_type
            }
          });
        } else {
          // 报到成功后查看，直接跳转回首页
          this.$router.push({
            path: "/rhwxSignIn",
            query: {
              map_type: this.$route.query.map_type,
              com_id: this.$route.query.com_id,
              sub_com_id: this.$route.query.sub_com_id
            }
          });
        }
      } else {
        document.body.scrollIntoView();
        setTimeout(() => {
          this.active = Number(this.active) + 1;
          this.params.notice = this.rowDataObj[Number(this.active)];
          // 设置背景
          if (this.params.notice.content.indexOf("data-background=") > 0) {
            document
              .getElementById("main")
              .setAttribute(
                "style",
                this.params.notice.content
                  .split('data-background="')[1]
                  .split('"')[0]
              );
          } else {
            document.getElementById("main").setAttribute("style", "");
          }
          document.title = this.params.notice.top_label || "安全告知书";
          // 如果报到成功，查看时不需要倒计时
          if (this.type !== "success") {
            this.scrollToBottom = false;
            this.isFirstScroll = true;
            this.count = 0;
          }
        }, 500);
      }
    },

    async getDetail() {
      this.$common
        .http({
          url: "/api/queue/driver/query_report_info",
          data: {
            com_id: this.$route.query.sub_com_id
          }
        })
        .then(res => {
          console.log(res);
          this.rowDataObj = res.data.data.safetyNotice;
          if (this.rowDataObj.length === 0) {
            this.$common.mbToastFail("当前无排队安全告知书信息");
            setTimeout(() => {
              this.$router.push({
                path: "/rhwxSignInSuccess",
                query: {
                  com_id: this.$route.query.com_id,
                  sub_com_id: this.$route.query.sub_com_id,
                  map_type: this.$route.query.map_type
                }
              });
            }, 2000);
          }
          for (let i = 0; i < this.rowDataObj.length; i++) {
            this.params[`notice${this.rowDataObj[i].type}`] = this.rowDataObj[
              i
            ];
          }
          this.params.notice = this.rowDataObj[0];
          // 设置背景
          if (this.params.notice.content.indexOf("data-background=") > 0) {
            document
              .getElementById("main")
              .setAttribute(
                "style",
                this.params.notice.content
                  .split('data-background="')[1]
                  .split('"')[0]
              );
          } else {
            document.getElementById("main").setAttribute("style", "");
          }
          document.title = this.params.notice.top_label || "安全告知书";
        });
    },

    //监听滚动
    Scrollbottom() {
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      let clientHeight = document.documentElement.clientHeight;
      let scrollHeight = document.documentElement.scrollHeight;
      if (scrollTop + clientHeight >= scrollHeight - 3) {
        this.scrollToBottom = true;
      }
    }
  },
  watch: {
    scrollToBottom() {
      // 1、已经滚动到底部
      // 2、未报到成功（即从报到页面跳转的）
      // 3、非第一次滚动到底部（防止重复设置）
      if (
        this.scrollToBottom &&
        this.type !== "success" &&
        this.isFirstScroll
      ) {
        this.count = 5;
        this.isFirstScroll = false;
      }
    },
    count() {
      setTimeout(() => {
        if (this.count > 0) {
          this.count--;
        }
      }, 1000);
    }
  },
  created() {
    window.addEventListener("scroll", this.Scrollbottom);
  },
  destroyed() {
    window.removeEventListener("scroll", this.Scrollbottom); //页面离开后销毁监听事件
  },
  computed: {
    type() {
      return this.$route.query.type || 0;
    }
  }
};
</script>
<style lang="less">
@import "../assets/css/common";
.notice-cont {
  box-sizing: border-box;
  // border-top: 1px solid #fff;
  width: 100%;
  overflow-x: hidden;
  #main {
    background-repeat: repeat !important;
    background-size: contain !important;
    background-size: 100% auto !important;
    margin-top: 70px !important;
  }
  .steps-blk {
    padding: 13px 35px 1px;
    box-shadow: 0 2px 4px 0 #f4f5f6;
    background: #fff;
    position: fixed;
    width: calc(100vw - 70px);
    min-height: 52px;
  }
  .one-step {
    font-size: 16px;
    color: #008b5e;
    display: flex;
    align-items: center;
    flex-flow: column;
  }
  .cont-title {
    text-align: center;
    font-size: 21px;
    line-height: 48px;
    padding: 75px 0px 0px;
  }
  .cont-time {
    text-align: center;
    font-size: 14px;
    color: #666666;
  }
  .cont-content {
    margin: 0px 16px 20px;
    font-size: 16px;
    line-height: 25px;
    width: calc(100vw - 32px);
    overflow: hidden;
    word-break: break-all;
  }
  .cont-footer {
    text-align: center;
    font-size: 14px;
    color: #999999;
    padding: 0px 0px 20px;
  }
  .cont-btn {
    // bottom: 0px;
    // width: 90%;
    // position: fixed;
    background: #f4f5f6;
    padding: 15px 5%;
    // z-index: 11;
  }
  .btnStyle1 {
    font-size: 18px;
    background: #009967;
    color: #fff;
  }
  .btnStyle1-1 {
    font-size: 18px;
    background: #cccccc;
    color: #fff;
  }
  // 控制序号样式
  .list-paddingleft-2 {
    margin: 0px 0px 0px 16px;
    word-break: break-all;
    width: calc(100vw - 48px) !important;
  }
}
// 步骤条样式
.van-steps--horizontal {
  padding: 0px 10px 0;
}
.van-step--finish {
  color: #008b5e;
}
.van-step--finish .van-step__circle,
.van-step--finish .van-step__line {
  background-color: #008b5e;
}
.van-step__icon--active,
.van-step__title--active {
  color: #008b5e;
}
.van-step__circle {
  display: block;
  width: 13px;
  height: 13px;
  border-radius: 50%;
}
.van-step--horizontal .van-step__title {
  font-size: 16px;
}
.van-step--horizontal .van-step__icon {
  font-size: 16px;
}
.van-steps {
  overflow: inherit;
}
.van-step--horizontal:first-child .van-step__title {
  margin-left: -11px;
}
.van-step--horizontal .van-step__title {
  margin-left: 15px;
  width: 24vw;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.van-step--horizontal:last-child .van-step__title {
  margin-right: -17px;
}
</style>
